import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap4-modal';

const DeleteConfigurationModal = ({ isVisible, toggleRemoveConfigModal, deleteMetric }) => {
  return (
    <Modal
      className='remove-component-modal'
      visible={isVisible}
      onClickBackdrop={toggleRemoveConfigModal}
    >
      <div className="modal-header">
        <h5 className="modal-title">Delete configuration</h5>
        <a
          onClick={(e) => { e.preventDefault(); toggleRemoveConfigModal(); }}
          className="close-delete-popup"
        >
          X
        </a>
      </div>
      <div className="modal-body">
        <p>Are you sure you want to delete this configuration?</p>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={toggleRemoveConfigModal}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={deleteMetric}
        >
          Delete
        </button>
      </div>
    </Modal>
  );
};

DeleteConfigurationModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleRemoveConfigModal: PropTypes.func,
  deleteMetric: PropTypes.func
};

DeleteConfigurationModal.defaultProps = {
  toggleRemoveConfigModal: () => { },
  deleteMetric: () => { }
};

export default DeleteConfigurationModal;



// WEBPACK FOOTER //
// ./src/components/dashboard/DeleteConfigurationModal.js